// eslint-disable-next-line import/prefer-default-export
export const SUBJECT_OPTIONS = [
  { value: 'INVALID', label: 'chat.chat_layout.subjects.order_helper' },
  { value: 'ORDER', label: 'chat.chat_layout.subjects.orders' },
  { value: 'MENU', label: 'chat.chat_layout.subjects.menu' },
  { value: 'SCHEDULE', label: 'chat.chat_layout.subjects.schedule' },
  { value: 'SUBSIDIARY', label: 'chat.chat_layout.subjects.susidiary' },
  { value: 'OTHER', label: 'chat.chat_layout.subjects.other' }
];
